import { EmailInfo } from 'types/types';

export const sendEmail = (EmailInfo: EmailInfo) => {
  const { to, subject, body } = EmailInfo;
  const url = new URL(`mailto:${to}`);

  const params = new URLSearchParams({
    subject,
    body,
  });

  url.search = params.toString().replace(/\+/g, '%20');

  return url.href;
};
